<template>
  <d-form>
    <d-form-row class="form-group mb-2">
      <!-- WordsPerGroup -->
      <d-col md="3" class="form-group">
        <label for="feWordsPerGroup">Palavras</label>
        <d-form-input
          type="number"
          id="feWordsPerGroup"
          min="1"
          placeholder="Quantidade de palavras por grupo"
          v-model="model.wordsPerGroup"
        />
      </d-col>
      <!-- GroupsPerMagazine -->
      <d-col md="3" class="form-group">
        <label for="feGroupsPerMagazine">Grupos</label>
        <d-form-input
          type="number"
          id="feGroupsPerMagazine"
          min="1"
          placeholder="Quantidade de grupos por revistas"
          v-model="model.groupsPerMagazine"
        />
      </d-col>
      <!-- TotalMagazines -->
      <d-col md="3" class="form-group">
        <label for="feTotalMagazines">Revistas</label>
        <d-form-input
          type="number"
          id="feTotalMagazines"
          min="1"
          placeholder="Quantidade de revistas"
          v-model="model.totalMagazines"
        />
      </d-col>
      <d-col cols="12">
        <div class="d-flex justify-content-between w-100 p-[5px]">
          <label class="d-flex align-items-end mb-0"> Lista de Palavras </label>
          <div class="d-flex justify-content-end">
            <d-button
              type="button"
              class="btn btn-success btn-sm py-1 px-3"
              @click="shuffleWordList"
              :disabled="disableShuffleButton"
            >
              Embaralhar lista de palavras
            </d-button>
            <d-button
              type="button"
              class="btn btn-primary btn-sm py-1 px-3 ml-2"
              @click="generateResult"
              :disabled="disableGenerateButton"
            >
              Gerar grupos de palavras
            </d-button>
          </div>
        </div>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group mb-1">
      <d-col cols="12">
        <textarea v-model="model.wordsList" class="form-control word-list" />
        <div
          class="d-flex justify-content-end align-items-center"
          v-if="model.wordsList"
        >
          <span class="custom-font">Total de palavras:</span>
          <span>{{ totalWords }}</span>
        </div>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group mt-3 mb-1">
      <d-col cols="12">
        <d-card
          class="mb-1"
          v-for="(magazine, index) in model.magazines"
          :key="index"
        >
          <d-card-header
            class="p-3 d-flex justify-content-between w-100 rounded"
            role="tab"
            @click.native="toggleAccordion(index)"
          >
            <span class="d-flex align-items-center justify-content-center mr-2">
              <i
                class="fas fa-chevron-right"
                :class="{ rotated: isOpen(index) }"
              />
            </span>
            <copy-text-title
              :title="`Revista ${index + 1}`"
              labelButton="Copiar palavras da revista"
              :onCopyText="() => copyMagazine(magazine, index)"
            />
          </d-card-header>
          <d-collapse
            :id="`accordionItem${index}`"
            :visible="isOpen(index)"
            class="p-4"
          >
            <d-form-row>
              <d-col cols="12" class="rounder">
                  <d-card-body class="d-flex flex-wrap justify-content-left p-0" style="gap: 10px;">
                    <d-card
                      v-for="(group, index) in magazine"
                      :key="index"
                      class="border p-2 rounded col-12 col-xl-2"
                      style="min-width: 250px;"
                    >
                    <d-card-body>
                      <copy-text-title
                        :title="`Grupo ${index + 1}`"
                        labelButton="Copiar palavras"
                        :onCopyText="() => copyText(group)"
                      />
                      <textarea
                        v-html="group"
                        disabled
                        class="form-control border-0 border-top text-area"
                      />
                    </d-card-body>
                    </d-card>
                  </d-card-body>
              </d-col>
            </d-form-row>
          </d-collapse>
        </d-card>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import { removeDuplicateLines } from '_utils';
import CopyTextTitle from './CopyTextTitle.vue';

export default {
  name: 'word-groups-form',
  components: {
    Editor,
    CopyTextTitle,
  },
  data() {
    return {
      timer: null,
      quill: null,
      openAccordions: [0],
      model: {
        wordsList: '',
        magazines: [],
        groupsPerMagazine: null,
        wordsPerGroup: null,
        totalMagazines: null,
      },
    };
  },
  computed: {
    totalWords() {
      const formattedWordsList = removeDuplicateLines(this.model.wordsList);
      return this.removeEmpty(formattedWordsList).length;
    },
    disableShuffleButton() {
      return !this.model.wordsList;
    },
    disableGenerateButton() {
      const emptyList = !this.model.wordsList;
      const invalidTotalMagazines = this.isInvalidSetting(this.model.totalMagazines);
      const invalidWordsPerGroup = this.isInvalidSetting(this.model.wordsPerGroup);
      const invalidGroupsPerMagazine = this.isInvalidSetting(this.model.groupsPerMagazine);
      const invalidSettings = invalidTotalMagazines || invalidWordsPerGroup || invalidGroupsPerMagazine;

      return emptyList || invalidSettings;
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    setQuill(quill) {
      this.quill = quill;
    },
    shuffleWordList() {
      this.setToggle({ type: 'progress', bool: true });
      const formattedWordsList = removeDuplicateLines(this.model.wordsList);
      const list = [...formattedWordsList.split('\n')];
      list.sort(() => Math.random() - 0.5);

      this.model.wordsList = list.join('\n');
      this.setToggle({ type: 'progress', bool: false });
      this.activeAlert({
        message: 'Lista Embarralhada com sucesso',
        theme: 'success',
      });
    },
    generateResult() {
      this.setToggle({ type: 'progress', bool: true });
      if (this.model.magazines.length > 0) {
        this.model.magazines = [];
      }

      const groups = [];
      const formattedWordsList = removeDuplicateLines(this.model.wordsList);
      const wordsList = [...formattedWordsList.split('\n')];
      const totalGroups =
        this.model.totalMagazines * this.model.groupsPerMagazine;
      const hasEnoughWords =
        wordsList.length >= totalGroups * this.model.wordsPerGroup;

      if (hasEnoughWords) {
        for (let index = 0; index < totalGroups; index += 1) {
          const group = wordsList.splice(0, this.model.wordsPerGroup);
          groups.push(group.join('\n'));
        }


        for (let index = 0; index < this.model.totalMagazines; index += 1) {
          const magazine = groups.splice(0, this.model.groupsPerMagazine);
          this.model.magazines.push(magazine);
        }

        this.activeAlert({
          message: 'Grupos gerados com sucesso',
          theme: 'success',
        });
      } else {
        const remainingWordCount = (totalGroups * this.model.wordsPerGroup) - wordsList.length;
        const wordText = remainingWordCount === 1 ? 'palavra' : 'palavras';
        const message = `Faltam ${remainingWordCount} ${wordText} para formar os grupos`;

        this.activeAlert({
          message,
          theme: 'danger',
        });
      }

      this.setToggle({ type: 'progress', bool: false });
    },
    copyMagazine(magazine, index) {
      let text = `Revista ${index + 1}\n\n`;

      magazine.forEach(group => {
        text += group;
        text += '\n\n';
      });

      navigator.clipboard.writeText(text).catch(err => {
        console.error('Erro ao copiar texto:', err);
      });
    },
    copyText(text) {
      navigator.clipboard.writeText(text).catch(err => {
        console.error('Erro ao copiar texto:', err);
      });
    },
    removeEmpty(text) {
      const list = text.split('\n');
      return list.filter(item => item.trim() !== '');
    },
    toggleAccordion(index) {
      if (this.openAccordions.includes(index)) {
        this.openAccordions = this.openAccordions.filter(i => i !== index);
      } else {
        this.openAccordions.push(index);
      }
    },
    isOpen(index) {
      return this.openAccordions.includes(index);
    },
    isInvalidSetting(setting) {
      return !setting || setting === '0';
    },
  },
};
</script>

<style lang="scss" scoped>
.word-list {
  min-height: 200px;
  resize: none;
}
.text-area {
  background-color: transparent;
  resize: none;
  padding-left: 0px;
  min-height: 200px;
  margin-top: 8px;
  height: auto;
}

.transparent-button {
  background-color: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: black;
  width: 20px;
}

.transparent-button:focus {
  outline: none;
  box-shadow: none;
}

.rotated {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.custom-font {
  font-weight: 700;
  margin-right: 8px;
}
</style>
